module.exports = __webpack_public_path__ + "img/car_shina2_24.dc8dc427.jpg";